import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IFaqSection } from '../../../classes/http-responses';
import { Constants } from '../../../classes/static/constants';
import { AppSettings } from '../../../app.settings';

@Component({
	selector: 'faqs-tab-content',
	template: require('./faqs-tab-content.component.html'),
})
export class FaqsTabContentComponent implements OnChanges {
	@Input() public isLoading: boolean = false;
	@Input() userType: string;
	@Input() public faqSections: IFaqSection[];
	public retailActiveSection: IFaqSection;
	public corporateActiveSection: IFaqSection;
	public isRebrading = AppSettings.isRebrading;

	ngOnChanges(simpleChanges: SimpleChanges): void {
		if (this.corporateActiveSection != null) {
			this.corporateActiveSection = this.faqSections.find(
				(s) =>
					s.userType.toLowerCase() == Constants.Corporate_Type.toLowerCase() &&
					s.sortOrder == this.corporateActiveSection.sortOrder
			);
		}
		if (this.retailActiveSection != null) {
			this.retailActiveSection = this.faqSections.find(
				(s) =>
					s.userType.toLowerCase() == Constants.Retail_Type.toLowerCase() &&
					s.sortOrder == this.retailActiveSection.sortOrder
			);
		}
	}

	public getActiveSection(): IFaqSection {
		if (this.userType == Constants.Corporate_Type) {
			return this.corporateActiveSection;
		} else if (this.userType == Constants.Retail_Type) {
			return this.retailActiveSection;
		}
	}

	public selectSection(section: IFaqSection): void {
		if (this.userType == Constants.Corporate_Type) {
			this.corporateActiveSection = Object.assign({}, section);
		} else if (this.userType == Constants.Retail_Type) {
			this.retailActiveSection = Object.assign({}, section);
		}
	}

	public isSectionActive(section: IFaqSection): boolean {
		return !!this.getActiveSection() && section.sortOrder == this.getActiveSection().sortOrder;
	}

	public displayIcon(section: IFaqSection): string {
		switch (section.title) {
			case 'Εγγραφή Νέου Πελάτη':
			case 'Digital Customer Onboarding':
				return 'register-new';
			case 'Κωδικοί & ασφάλεια':
			case 'Credentials & security':
				return 'security-faq';
			case 'Ενημέρωση προϊόντων':
				return 'product-faq';
			case 'Συναλλαγές':
			case 'Transactions':
				return 'transactions-faq';
			case 'Υπηρεσίες':
			case 'Services':
				return 'services-faq';
			case 'Γενικές Ερωτήσεις':
			case 'General Questions':
				return this.isRebrading ? 'question-faq' : 'question-not-selected';
			case 'Video Tutorials':
				return 'video-faq';
			default:
				return 'None';
		}
	}
}
